import React, { useState, useEffect } from 'react';
import Nav from '../components/Nav/Nav';
import {
  ArrowLeftOutlined,
  PlusOutlined,
  LoadingOutlined,
  DeleteOutlined,
  SettingFilled,
  CloseOutlined
} from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import imageCompression from 'browser-image-compression';
import { IoSparkles } from "react-icons/io5";

import '../App.css';

function Product() {
  const {
    currentProduct,
    updateProduct,
    deleteProduct,
    isLoading,
    productM,
    listCategories,
    getCategories,
    getProduct,
    t,
    translated,
    languages,
    tOption,
    translated2,
    t2,
    ai,
    generated,
    isgenerating,
    getRestaurant,
    currentRestaurant,
    currentUser,
    uploadPhotoFile,
    uploadDigitalProductFile,
    getDigitalFileUrl
  } = useAuth();

  const navigate = useNavigate();
  const { id } = useParams();

  const [name, setName] = useState('');
  const [price, setPrice] = useState(0);
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');
  const [existingPhotos, setExistingPhotos] = useState([]);
  const [newPhotos, setNewPhotos] = useState([]);
  const [newPreviews, setNewPreviews] = useState([]);
  const [status, setStatus] = useState('visible');
  const [checkboxState, setCheckboxState] = useState({});
  const [hide, setHide] = useState(false);
  const [checkboxStateOpt, setCheckboxStateOpt] = useState({});
  const [langSelected, setLangSelected] = useState([]);
  const [options, setOptions] = useState([]);
  const [allergens, setAllergens] = useState('');
  const [checkboxState2, setCheckboxState2] = useState({});
  const [label, setLabel] = useState('');
  const [adress, setAdress] = useState('');
  const [position, setPosition] = useState('');
  const [isPersonalized, setIsPersonalized] = useState(false);
  const [descriptionTrans, setDescriptionTrans] = useState({});
  const [quantity, setQuantity] = useState(0);
  const [optionMode, setOptionMode] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [digitalFile, setDigitalFile] = useState(null);
  const [digitalFileName, setDigitalFileName] = useState('');
  const [digitalFilePath, setDigitalFilePath] = useState('');

  const MAX_OPTIONS = 8;
  const MAX_FILE_SIZE = 50 * 1024 * 1024;

  const isDigitalProduct = currentRestaurant?.productType === 'digital';

  const createOptionId = () =>
    `opt_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;

  useEffect(() => {
    getProduct(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (!currentProduct?.restaurant) return;
    getRestaurant(currentProduct.restaurant);
    getCategories(currentProduct.restaurant);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentProduct]);

  useEffect(() => {
    if (!currentUser) window.history.back();
  }, [currentUser]);

  useEffect(() => {
    if (langSelected.length === languages?.length && options.length > 0) {
      tOption(options, langSelected);
      setLangSelected([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [langSelected]);

  useEffect(() => {
    if (!currentProduct) return;

    const existingOptions = currentProduct.translatedOpt || [];

    setName(currentProduct.name || '');
    setCategory(currentProduct.category || '');
    setPrice(currentProduct.price || 0);
    setStatus(currentProduct.status || 'visible');
    setExistingPhotos(
      currentProduct.pictures?.length
        ? currentProduct.pictures
        : currentProduct.picture
        ? [currentProduct.picture]
        : []
    );
    setNewPhotos([]);
    setNewPreviews([]);
    setDescription(currentProduct.description || '');
    setDescriptionTrans(currentProduct.translated || {});
    setQuantity(Number(currentProduct.quantity || 0));

    setDigitalFile(null);
    setDigitalFileName(currentProduct.digitalFileName || '');
    setDigitalFilePath(currentProduct.digitalFilePath || '');

    if (currentRestaurant?.productType === 'digital') {
      setOptions([]);
      setAllergens('');
      setLabel('');
      setOptionMode('');
      setHide(true);
    } else {
      setOptions(existingOptions);
      setAllergens(currentProduct.allergens || '');
      setLabel(currentProduct.label || '');

      if (existingOptions.length > 0) {
        setOptionMode(String(existingOptions[0]?.type || ''));
        setHide(false);
      } else {
        setOptionMode('');
        setHide(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentProduct, currentRestaurant]);

  useEffect(() => {
    if (currentRestaurant) {
      setAdress(currentRestaurant.adress || '');
      setPosition(currentRestaurant.hours || '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentRestaurant]);

  useEffect(() => {
    if (!options?.length) return;

    const hasMissingIds = options.some((opt) => !opt?.id);
    if (!hasMissingIds) return;

    setOptions((prev) =>
      prev.map((opt) => ({
        ...opt,
        id: opt?.id || createOptionId(),
      }))
    );
  }, [options]);

  const optionsToSave =
    JSON.stringify(options) !== JSON.stringify(currentProduct?.translatedOpt || [])
      ? options
      : currentProduct?.translatedOpt || [];

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isLoading || isSubmitting) return;

    setIsSubmitting(true);

    try {
      let finalDigitalFileName =
        digitalFileName || currentProduct?.digitalFileName || '';

      let finalDigitalFilePath =
        digitalFilePath || currentProduct?.digitalFilePath || '';

      const uploadedNewUrls = await Promise.all(newPhotos.map(uploadPhotoFile));
      const finalPictures = [...existingPhotos, ...uploadedNewUrls];
      const finalPhotoUrl = finalPictures[0] || '';

      if (isDigitalProduct && digitalFile) {
        const uploaded = await uploadDigitalProductFile(
          digitalFile,
          currentProduct.restaurant
        );
        if (!uploaded) {
          alert("Impossible d'uploader le fichier digital.");
          return;
        }

        finalDigitalFileName = uploaded.name;
        finalDigitalFilePath = uploaded.path;
      }

      await updateProduct(
        id,
        name,
        price,
        description,
        category,
        finalPhotoUrl,
        status,
        currentProduct?.position,
        description !== currentProduct.description ? translated : descriptionTrans,
        !isDigitalProduct ? optionsToSave : [],
        !isDigitalProduct
          ? (allergens !== currentProduct.allergens
              ? translated2
              : currentProduct.translated2)
          : {},
        !isDigitalProduct ? allergens : '',
        !isDigitalProduct
          ? (currentProduct.label
              ? (currentProduct.label !== label ? label : currentProduct.label)
              : label)
          : '',
          isDigitalProduct ? 1000000 : Number(quantity || 0),
        isDigitalProduct ? finalDigitalFileName : '',
        !!isDigitalProduct,
        isDigitalProduct ? finalDigitalFilePath : '',
        finalPictures
      );
    } catch (error) {
      console.log(error);
      alert("Erreur pendant l'enregistrement du produit.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCheckboxChange = (code) => {
    setCheckboxState((prevState) => ({
      ...prevState,
      [code]: !prevState[code],
    }));
    t(description, code);
  };

  const handleInputChange = (languageCode, newValue) => {
    setDescriptionTrans((prevDescriptionTrans) => ({
      ...prevDescriptionTrans,
      [languageCode]: newValue,
    }));
  };

  const removeOption = (indexToRemove) => {
    const nextOptions = options.filter((_, index) => index !== indexToRemove);
    setOptions(nextOptions);

    if (nextOptions.length === 0) {
      setOptionMode('');
      setHide(true);
    }
  };

  const handleAddPhoto = (event) => {
    const imageFile = event.target.files[0];
    if (!imageFile) return;
    event.target.value = '';

    if (existingPhotos.length + newPhotos.length >= 5) return;

    const compressionOptions = { maxSizeMB: 1, maxWidthOrHeight: 700, useWebWorker: true };

    imageCompression(imageFile, compressionOptions)
      .then((compressedFile) => setNewPhotos((prev) => [...prev, compressedFile]))
      .catch((error) => console.log(error.message));

    const reader = new FileReader();
    reader.onloadend = () => setNewPreviews((prev) => [...prev, reader.result]);
    reader.readAsDataURL(imageFile);
  };

  const handleRemoveExisting = (index) => {
    setExistingPhotos((prev) => prev.filter((_, i) => i !== index));
  };

  const handleRemoveNew = (index) => {
    setNewPhotos((prev) => prev.filter((_, i) => i !== index));
    setNewPreviews((prev) => prev.filter((_, i) => i !== index));
  };

  const handleDigitalFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();

    const isZip =
      file.type === 'application/zip' ||
      file.type === 'application/x-zip-compressed' ||
      fileName.endsWith('.zip');

    if (!isZip) {
      alert('Seuls les fichiers .zip sont acceptés.');
      event.target.value = '';
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      alert('Le fichier est trop volumineux. Taille maximale : 50 MB.');
      event.target.value = '';
      return;
    }

    setDigitalFile(file);
    setDigitalFileName(file.name);
    setDigitalFilePath('');
  };

  const handleAddOption = (type) => {
    if (!type || isDigitalProduct) return;
    if (options.length >= MAX_OPTIONS) return;
    if (optionMode && optionMode !== type) return;

    setOptionMode(type);
    setHide(true);
    setOptions((prev) => [
      ...prev,
      { id: createOptionId(), name: '', price: '', type }
    ]);
    setCheckboxStateOpt({});
  };

  const handleOptionChange = (index, field, value) => {
    const updatedOptions = [...options];
    updatedOptions[index][field] = value;
    setOptions(updatedOptions);
  };

  const handleCheckboxChange2 = (code) => {
    setCheckboxState2((prevState) => ({
      ...prevState,
      [code]: !prevState[code],
    }));
    t2(allergens, code);
  };

  const handleCheckboxChangeOpt = (code) => {
    setCheckboxStateOpt((prevState) => ({
      ...prevState,
      [code]: !prevState[code],
    }));
    setLangSelected((prev) => [...prev, code]);
  };

  const canAddOptionType = !optionMode || optionMode === '1';
  const canAddSupplementType = !optionMode || optionMode === '2';
  const reachedMaxOptions = options.length >= MAX_OPTIONS;
  const submitLoading = isLoading || isSubmitting;

  return (
    <div className="one-page">
      <Nav />
      <div className="main">
        <form onSubmit={handleSubmit} className='wrapper-container'>
          {currentProduct?.name ? (
            <div className='wrapper-content'>
              <div className='title-wrapper'>
                <div className='title-back'>
                  <ArrowLeftOutlined onClick={() => navigate(-1)} className='back' />
                  <p>{currentProduct.name}</p>
                </div>
              </div>

              <div className='wrapper-form'>
                <div className='input-container'>
                  <label htmlFor="name">Nom du produit</label>
                  <input
                    type="text"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>

                <div className='input-container'>
                  <label htmlFor="price">Prix</label>
                  <input
                    type="number"
                    id="price"
                    value={price}
                    min="0"
                    step="0.01"
                    onChange={(e) => setPrice(e.target.value)}
                    required
                    placeholder='€'
                  />
                </div>

                {!generated && !isgenerating && (
                  <p
                    style={{ textAlign: 'right', cursor: 'pointer', display: 'none' }}
                    onClick={() =>
                      ai(`recommande un prix pour ce produit ${name} dans un resto sur un positionnement de ${position} au ${adress}`)
                    }
                  >
                    Recommandation de l'IA <IoSparkles />
                  </p>
                )}

                {isgenerating && (
                  <LoadingOutlined spin style={{ fontStyle: 'italic', textAlign: 'right', float: 'right' }} />
                )}

                <div className="modify-translation-container">
                  <div className="modify-translation">
                    <p style={{ fontStyle: 'italic', textAlign: 'right', fontSize: 14, marginRight: 1 }}>
                      {generated}
                    </p>
                  </div>
                </div>
                {!isDigitalProduct && (
                <div className='input-container'>
                  <label htmlFor="quantity">Stock disponible</label>
                  <input
                    type="number"
                    id="quantity"
                    min="0"
                    step="1"
                    value={quantity}
                    onChange={(e) => setQuantity(Number(e.target.value))}
                    required
                  />
                </div>
              )}
                <div className='input-container'>
                  <label htmlFor="category">Catégorie</label>
                  <select
                    id="category"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    required
                  >
                    {listCategories?.map((categorie) => (
                      <option key={categorie.id} value={categorie.id}>
                        {categorie.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className='input-container'>
                  <label htmlFor="description">Description</label>
                  <input
                    type="text"
                    id="description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>

                <p
                  style={{ textAlign: 'right', cursor: 'pointer', display: 'none' }}
                  onClick={() => setIsPersonalized(!isPersonalized)}
                >
                  Personnaliser <SettingFilled />
                </p>

                {isPersonalized && (
                  <div className='modify-translation-container'>
                    <div className='modify-translation'>
                      {Object.entries(descriptionTrans).map(([languageCode, translation]) => (
                        <div style={{ display: 'flex', alignContent: 'center' }} key={languageCode}>
                          <p style={{ marginRight: 10, width: 30, display: 'flex', alignItems: 'center' }}>
                            {languageCode}:
                          </p>
                          <input
                            style={{ width: '100%' }}
                            type="text"
                            value={translation}
                            onChange={(e) => handleInputChange(languageCode, e.target.value)}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className='input-container' style={{ height: 'auto' }}>
                  <label>Photos</label>
                  <div className="photo-grid">
                    {existingPhotos.map((url, i) => (
                      <div key={`e-${i}`} className="photo-grid-item">
                        <img src={url} alt="" className="photo-grid-thumb" />
                        <button type="button" className="photo-grid-remove" onClick={() => handleRemoveExisting(i)}>
                          <CloseOutlined />
                        </button>
                      </div>
                    ))}
                    {newPreviews.map((preview, i) => (
                      <div key={`n-${i}`} className="photo-grid-item">
                        <img src={preview} alt="" className="photo-grid-thumb" />
                        <button type="button" className="photo-grid-remove" onClick={() => handleRemoveNew(i)}>
                          <CloseOutlined />
                        </button>
                      </div>
                    ))}
                    {existingPhotos.length + newPhotos.length < 5 && (
                      <div className="photo-grid-item photo-grid-add">
                        <PlusOutlined />
                        <span className="photo-grid-hint">800×800 px</span>
                        <input className="inputfile" type="file" accept="image/*" onChange={handleAddPhoto} />
                      </div>
                    )}
                  </div>
                </div>

                {isDigitalProduct && (
  <div className="input-container" style={{ height: 'auto' }}>
    <label htmlFor="digitalFile">Fichier digital</label>

    <div className="digital-file-container">
      <label htmlFor="digitalFile" className="digital-file-button">
        Remplacer le fichier ZIP
      </label>

      <input
        className="digital-file-input"
        type="file"
        id="digitalFile"
        accept=".zip,application/zip,application/x-zip-compressed"
        onChange={handleDigitalFileChange}
      />

      <p className="digital-file-help">
        {digitalFile
          ? `${digitalFile.name}`
          : currentProduct?.digitalFileName
          ? `${currentProduct.digitalFileName}`
          : 'Aucun fichier'}
      </p>

      {currentProduct?.digitalFilePath && (
        <button
          type="button"
          className="digital-file-download"
          onClick={async () => {
            const fileUrl = await getDigitalFileUrl(currentProduct.digitalFilePath);
            if (!fileUrl) {
              alert("Impossible d'ouvrir le fichier.");
              return;
            }
            window.location.href = fileUrl;
          }}
        >
          Télécharger le fichier actuel
        </button>
      )}
    </div>
  </div>
)}

                {!isDigitalProduct && (
                  <div className='input-container'>
                    <label htmlFor="allergen">Allèrgenes</label>
                    <input
                      type="text"
                      id="allergen"
                      value={allergens}
                      placeholder='Exemple : Noix - Oeuf - Lait'
                      onChange={(e) => setAllergens(e.target.value)}
                    />
                  </div>
                )}

                {!isDigitalProduct && (
                  <div className='input-container'>
                    <label htmlFor="label">Label</label>
                    <select
                      id="label"
                      value={label}
                      onChange={(e) => setLabel(e.target.value)}
                    >
                      <option value="">Choisir un label</option>
                      <option value="vegetarien">Végétarien</option>
                      <option value="halal">Halal</option>
                    </select>
                  </div>
                )}

                <div className='input-container'>
                  <label htmlFor="status">Status</label>
                  <select
                    id="status"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    required
                  >
                    <option value="visible">Visible</option>
                    <option value="hidden">Masqué</option>
                  </select>
                </div>

                {currentProduct && description !== currentProduct?.description && (
                  <div className='input-container' style={{ display: 'none' }}>
                    <label htmlFor="checkbox">Traduction</label>

                    <div className='checkbox-container'>
                      {languages.map((language) => (
                        <label key={language.code}>
                          <input
                            type="checkbox"
                            checked={checkboxState[language.code] || false}
                            onChange={() => handleCheckboxChange(language.code)}
                          />
                          {language.name}
                        </label>
                      ))}
                      <div>{Object.keys(translated)?.length}</div>
                    </div>
                  </div>
                )}

                {!isDigitalProduct && allergens && allergens !== currentProduct?.allergens && (
                  <div className='input-container' style={{ display: 'none' }}>
                    <label htmlFor="checkbox">Traduction</label>

                    <div className='checkbox-container'>
                      {languages.map((language) => (
                        <label key={language.code}>
                          <input
                            type="checkbox"
                            checked={checkboxState2[language.code] || false}
                            onChange={() => handleCheckboxChange2(language.code)}
                          />
                          {language.name}
                        </label>
                      ))}
                    </div>
                  </div>
                )}

                {!isDigitalProduct && options.length > 0 && !hide && (
                  <div className='wrapper-modify-opt'>
                    <div className='modify-opt-header'>
                      <p>{options[0]?.type === '2' ? 'Suppléments' : 'Options'}</p>
                      <span onClick={() => setHide(true)}>Modifier</span>
                    </div>

                    <div className='modal-option'>
                      {options.map((item, index) => (
                        <div key={item.id || index} className='modal-text-option modify-opt-text'>
                          <p>{item.name}</p>
                          <p>{`${item.price} €`}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {!isDigitalProduct && hide && (
                  <>
                    <div className='validation-container extra-container'>
                      <label htmlFor="label">Extra</label>

                      {canAddOptionType && !reachedMaxOptions && (
                        <button
                          style={{ marginLeft: 10 }}
                          className='button save more-option'
                          type="button"
                          onClick={() => handleAddOption('1')}
                        >
                          Ajouter une option
                        </button>
                      )}

                      {canAddSupplementType && !reachedMaxOptions && (
                        <button
                          className='button save more-option'
                          type="button"
                          onClick={() => handleAddOption('2')}
                        >
                          Ajouter un supplément
                        </button>
                      )}
                    </div>

                    {options.map((option, index) => (
                      <div key={option.id || index} className="option-wrapper">
                        <div className='input-container'>
                          <label htmlFor={`option-name-${index}`}>
                            {option.type === '2'
                              ? `supplément ${index + 1}`
                              : `option ${index + 1}`}
                          </label>

                          <div className='option-container'>
                            <DeleteOutlined onClick={() => removeOption(index)} />

                            <input
                              type="text"
                              className='input-option-name'
                              id={`option-name-${index}`}
                              value={option.name}
                              onChange={(e) => handleOptionChange(index, 'name', e.target.value)}
                              placeholder='Nom'
                            />

                            <input
                              type="number"
                              className='input-option-price'
                              id={`option-price-${index}`}
                              value={option.price}
                              min="0"
                              step="0.01"
                              onChange={(e) => handleOptionChange(index, 'price', e.target.value)}
                              placeholder='Prix'
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                )}

                {!isDigitalProduct && options.length > 0 && hide && (
                  <div className='input-container' style={{ display: 'none' }}>
                    <label htmlFor="checkbox">Traduction</label>

                    <div className='checkbox-container'>
                      {languages.map((language) => (
                        <label key={language.code}>
                          <input
                            type="checkbox"
                            checked={checkboxStateOpt[language.code] || false}
                            onChange={() => handleCheckboxChangeOpt(language.code)}
                          />
                          {language.name}
                        </label>
                      ))}
                      <div>{langSelected?.length}</div>
                    </div>
                  </div>
                )}

                <div className='validation-container'>
                  <button
                    className='button save'
                    type="submit"
                    disabled={submitLoading}
                  >
                    {submitLoading ? <LoadingOutlined spin /> : 'Enregistrer'}
                  </button>

                  {productM ? (
                    <div className='delete info'>{productM}</div>
                  ) : (
                    <div className='delete' onClick={() => deleteProduct(id)}>
                      Supprimer
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <LoadingOutlined spin />
          )}
        </form>
      </div>
    </div>
  );
}

export default Product;